import BzbsApi from "@/core/Http/BzbsApi"
import { ref } from "vue"

//#region type def
/**
 * @typedef {Object} GetTheOneProfile
 * @property {string} uniqueRefID
 * @property {string} authCode
 */

/**
 * @typedef {Object} Bitkubtransaction
 * @property {string} tranid
 * @property {string} rate
 * @property {string} balance
 * @property {string} info2
 * @property {string} info3
 * @property {string} info4
 * @property {string} info5
 * @property {string} withholdingtax_key
 */
//#endregion

export const useBitkub = function (states) {
    const baseUrl = ref('')
    const userPoints = ref(0)
    const walletAddress = ref('')

    const initService = function () {
        baseUrl.value = states.blobWebLanding[states.mainAppName]
    }

    const updatePoints = function (data) {
        console.log(data)
        let newPoints = data?.updated_points?.points ?? 0
        if (newPoints != 0) {
            userPoints.value = newPoints
        }
    }

    const methods = {
        check: function () {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/check_token"
                BzbsApi.connectBzbsPost(url, states.query.token, null).subscribe({
                    next: (res) => {
                        // console.log(res)
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        },
        /**
         *
         * @param {RedeemTheOneParams} params
         * @returns
         */
        convert: function (params) {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/redeem"
                BzbsApi.connectBzbsPost(url, states.query.token, params).subscribe({
                    next: (res) => {
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        }
    }

    return {
        walletAddress,
        methods,
        initService,
        userPoints,
        updatePoints
    }
}

export default useBitkub
